
export default function MultiplicationGameAnswer({answer}) {
    // Used in MultiplicationGameAnsweringBlock

    // BUILD
    return (
        <div className={"bg-blueBackground h-[72px] w-[160px] min-w-[160px] flex justify-center items-center border-[2px] border-timerBlue rounded-[8px] ml-[4px]"}>
            <span className={"text-white font-medium text-[40px]"}>
                {answer}
            </span>
        </div>
    );
}